import React from 'react';
import { ITeacher } from 'models/Providers/Teacher';
import ShowcaseTeacherRow from 'parent-portal/home/new/components/ShowcaseTeacherRow';
import { Colors, CompactButton } from 'library';
import { ChevronRight } from '@mui/icons-material';
import { styled } from '@mui/material';

export default function PublicTeacherCard({ worker }: { worker: ITeacher }) {
    function openSignUp() {
        window.open('/signup', '_blank');
    }

    return (
        <ShowcaseTeacherRow
            worker={worker}
            rightAction={
                <CompactButton
                    onClick={openSignUp}
                    buttonStyle={{ whiteSpace: 'nowrap', backgroundColor: Colors.darkNavy }}
                    textStyle={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: 4,
                        color: Colors.white,
                        padding: 2,
                    }}
                >
                    Request {worker.name}
                    <IconCircle>
                        <ChevronRight htmlColor={Colors.white} style={{ fontSize: 16 }} />
                    </IconCircle>
                </CompactButton>
            }
        />
    );
}

const IconCircle = styled('div')({
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: Colors.darkNavy,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});
